import { useQuery } from "@tanstack/react-query";
import { getExpensesHistory } from "../services";
import type {
	ExpensesHistoryPaginatedResponse,
	ExpensesHistoryPeriod,
} from "../types";

export function useGetExpensesHistory(payload: ExpensesHistoryPeriod) {
	return useQuery<ExpensesHistoryPaginatedResponse>({
		queryKey: ["expenses", "history", payload],
		queryFn: () => getExpensesHistory(payload),
		enabled:
			!!payload.startDate &&
			!!payload.endDate &&
			!!payload.pageNumber &&
			!!payload.pageSize,
	});
}
